import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WorkstationFacade } from '@app/store/workstation';
import { filter, map, tap } from 'rxjs';

export const workstationSelected = (): CanActivateFn => {
    return () => {
        const router = inject(Router);
        const workstationFacade = inject(WorkstationFacade);

        return workstationFacade.loaded$.pipe(
            tap((loaded) => {
                if (loaded === null) {
                    workstationFacade.getWorkstation();
                }
            }),
            filter((loaded) => loaded !== null),
            map(() => {
                return workstationFacade.workstation() ? true : router.createUrlTree(['/', 'workstation']);
            }),
        );
    };
};
